export default {
  apply: {
    congrat_1_steps: "1. Scannez le QR code depuis l'appareil photo de votre Smartphone",
    congrat_2_steps: "2. Téléchargez l'application et finalisez votre profil",
    congrat_3_steps: '3. Accédez à votre condidature et aux centaines de missions près de chez vous',
    download_app: 'Télécharger',
    form_address_label: 'Adresse',
    form_address_placeholder: '21 rue de Châteaudun 75008, Paris',
    form_email_label: 'Email',
    form_email_placeholder: 'johndoe@iziwork.com',
    form_firstname_label: 'Prénom',
    form_firstname_placeholder: 'John',
    form_lastname_label: 'Nom',
    form_lastname_placeholder: 'Doe',
    form_phone_label: 'Téléphone',
    form_phone_placeholder: '06 63 63 63 63',
    form_resume_button: 'Importer',
    form_resume_label: 'CV',
    message_info_accept_tcu: 'En continuant, vous acceptez les',
    tcu_confidentiality: "Conditions Générales d'Utilisation",
    message_info_accept_conditions: 'ainsi que la',
    tcu_conditions: 'Politique de Confidentialité',
    modal_action_apply: 'Postuler',
    modal_action_close: 'Fermer',
    step_unknown: {
      dropzone: {
        drop: 'Glissez déposez ou ',
        select: 'sélectionnez votre fichier',
        supported_files: 'Fichiers supportés : IMAGES, PDF, DOC, DOCX',
      },
    },
    subtitle_download_app: 'Téléchargez notre application pour suivre votre candidature.',
    subtitle_email_to_identify: "Votre email nous permet d'identifier si nous nous connaissons déjà.",
    subtitle_resume_to_apply: 'Nous avons besoin de votre CV et de vos coordonnés pour traiter votre candidature.',
    title_free_apply: 'Postuler pour une mission',
    title_job_offer_apply: 'Postuler pour cette mission',
    title_congratulation: 'Bravo, votre candidature a bien été envoyée !',
    title_you_are_new: 'Nous ne nous connaissons pas encore !',
  },
  free_application_card: {
    button: "C'est parti",
    message: 'Envoyez votre CV et nous vous contacterons dès que nous aurons trouvé une offre pour vous.',
    title: 'Vous cherchez un emploi ?',
  },
  banner: {
    join_community: 'Rejoignez la communauté',
    large_choice: 'Large choix de missions',
    large_choice_desc:
      'J’ai accès à un large choix de missions en intérim, CDD, CDI dans ma région, sur tous les métiers qui m’intéressent.',
    personal_service: 'Suivi personnalisé & valorisé',
    personal_service_desc:
      'Mon chargé de recrutement dédié m’accompagne au jour le jour. Plus je travaille avec iziwork, plus je bénéficie d’avantages !',
    simple_and_fast: 'Simple & rapide',
    simple_and_fast_desc:
      "Plus de déplacements en agence : je choisis ma mission en 3 clics, j'ajoute simplement mes documents.",
  },
  browse_page: {
    heading: 'Découvrez toutes nos offres près de :',
    title: 'Nos emplois autour de chez vous',
  },
  consent_manager: {
    content:
      'Nous utilisons l’information collectée par des cookies et des librairies JavaScript pour améliorer votre expérience de navigation, analyser le trafic sur notre site, afficher des publicités personnalisées et augmenter la performance de notre site.',
    title: 'Gérer mes préférences',
  },
  currencies: {
    EUR: '€',
    USD: '$',
  },
  date: {
    today: "aujourd'hui",
  },
  error_pages: {
    internal_server_error_title: "Oops, une erreur s'est produite...",
    not_found_subtitle1: 'Mais ne vous inquiétez pas, nos développeurs la recherchent!',
    not_found_subtitle2: "Jusqu'à ce qu'ils trouvent, vous pouvez revenir à l'accueil.",
    not_found_title: 'Oups, il semble que la page que vous regardiez a disparu.',
    redirect_label: "Revenir à l'accueil",
  },
  field_errors: {
    address_valueIncomplete: "L'adresse est incomplète",
    address_valueMissing: "L'adresse est obligatoire",
    captcha_valueMissing: 'Le champs est obligatoire',
    email_typeMismatch: "L'email est incorrect",
    email_valueMissing: "L'email est obligatoire",
    firstname_valueMissing: 'Le prénom est obligatoire',
    lastname_valueMissing: 'Le nom est obligatoire',
    phone_typeMismatch: 'Le téléphone est incorrect',
    phone_valueMissing: 'Le téléphone est obligatoire',
    resume_invalidSize: 'La taille du fichier doit être comprise entre 1Ko et 10Mo',
    resume_invalidType: 'Le type de fichier est invalide',
    resume_valueMissing: 'Le CV est obligatoire',
  },
  footer: {
    aboutUs: 'À propos de nous',
    account: 'Se connecter',
    askADemo: 'Demander une démo',
    blog: 'Blog',
    browse: 'Parcourir les emplois',
    companies: 'Entreprises',
    companySpace: 'Espace entreprises',
    confidentiality: 'Politique de confidentialité',
    cookies_policy: 'Politique de cookies',
    cookies_settings: 'Paramètres de cookies',
    join: 'Nous rejoindre',
    legalMentions: 'Mentions légales',
    partners: 'Partners',
    personalData: 'Données personnelles',
    press: 'Espace Presse',
    program: 'Programme Partners',
    socialMedia: {
      facebook: 'Nous suivre sur Facebook',
      instagram: 'Voir nos stories Instagram',
      linkedin: 'Nous ajouter sur LinkedIn',
      twitter: 'Voir nos stories Twitter',
    },
    usageConditions: "Conditions d'utilisation",
    who: 'Qui sommes nous?',
    why: 'Pourquoi Iziwork ?',
    worker: 'Intérimaires',
  },
  form_errors: {
    address: 'Veuillez sélectionner une ville',
    job: 'Veuillez entrer un métier',
  },
  form_labels: {
    address: 'Ville',
    distance: '< {{distance}} km',
    experience: 'Expérience requise',
    job: 'Métier',
    sort: 'Trier par',
    type: 'Type de contrat',
  },
  form_option_labels: {
    experience: {
      all: 'Toutes',
      any: 'Première expérience requise',
      five_years: 'Plus de 5 ans',
      none: 'Pas d’expérience requise',
      one_month: 'Au moins 1 mois',
      one_year: 'Au moins 1 an',
      six_months: 'Au moins 6 mois',
      three_months: 'Au moins 3 mois',
      two_years: 'Entre 2 ans et 5 ans',
    },
    sort: {
      publication: 'Date de publication',
      relevance: 'Pertinence',
    },
    type: {
      all: 'Tous',
      contract: 'CDD',
      non_seasonal_temporary: 'Intérim',
      permanent: 'CDI',
      seasonal_temporary: 'Intérim',
      temporary: 'Intérim',
    },
    urgent: 'Urgente',
  },
  form_option_values: {
    experience: {
      any: 'premiere',
      five_years: '5 ans et plus',
      none: 'aucune',
      one_month: '1 mois',
      one_year: '1 an',
      six_months: '6 mois',
      three_months: '3 mois',
      two_years: '2 ans et plus',
    },
    sort: {
      publication: 'publication',
      relevance: 'pertinence',
    },
    type: {
      contract: 'cdd',
      non_seasonal_temporary: 'interim non saisonnier',
      permanent: 'cdi',
      seasonal_temporary: 'intérim saisonnier',
      temporary: 'interim',
    },
  },
  form_placeholders: {
    address: 'Rechercher une ville',
    job: 'Rechercher un métier',
  },
  form_title: 'Votre recherche pour',
  header: {
    findMission: 'Trouver un job',
    myApply: 'Mes Applications',
    partners: 'Avis sur les entreprises',
  },
  languages: {
    dev: 'dev',
    en: 'English',
    fr: 'Français',
    it: 'Italiano',
  },
  'meta-description': {
    jobOffer: {
      suffix: 'Candidatez en 3 clics maintenant, travaillez demain !',
      type: {
        contract: 'Consultez notre mission en CDD de {{title}} à {{city}}.',
        permanent: 'Consultez notre mission en CDI de {{title}} à {{city}}.',
        temporary: 'Consultez notre mission en intérim de {{title}} à {{city}}.',
      },
    },
  },
  'meta-social-description': {
    mission_description:
      'Découvrez notre mission de {{displayName}} près de {{city}}. Candidatez en 3 clics maintenant, travaillez demain !',
    mission_title: "{{displayName}} - {{city}} ({{areaCode}}) - Offre d'emploi",
    partner_description: 'Des dizaines de postes à pourvoir près de {{city}} ! Candidature facile et rapide.',
    partner_title: "Nos offres d'emploi près de {{city}} ({{areaCode}})",
  },
  missions: {
    about: 'À propos de la mission',
    apply: 'Postuler',
    back: 'Revenir à la recherche',
    bonuses: 'Avantages',
    certificates: 'Certificats',
    close_distance: 'proche',
    contractType: 'Type de contrat',
    details_tab_label: 'Détails',
    distance: 'à {{distance}} km',
    experience: 'Expérience',
    informations: 'Informations',
    location: 'Lieu',
    no_certificates_required: 'Aucun certificat requis',
    no_experience_required: "Pas d'expérience requise - jeunes, travailleurs sans qualifications.. bienvenus",
    outdated: {
      oops_text: "cette offre d'emploi n'existe plus.",
      subtitle: "Téléchargez l'application pour accéder à toutes les missions iziwork",
    },
    profile: 'Profil recherché',
    published: 'Parue ',
    remuneration: 'Rémunération',
    see_all_missions: 'Voir toutes ses missions',
    weekly_hours: {
      default: '{{hours}} heures / semaine',
      hours: '{{hours}} heures',
      per_week: 'par semaine',
    },
    workTime: 'Temps de travail',
  },
  no_mission_modal: {
    button: {
      close: 'Fermer',
      next: 'Suivant',
    },
    download_app: 'Téléchargez l’application iziwork dès maintenant !',
    download_app_subtitle: "Inscrivez-vous et complétez votre profil en 5mn grâce à notre système d'analyse de CV.",
    placeholder: {
      email: 'Votre adresse email',
      phone: 'Votre numéro de téléphone',
    },
    step: 'Étape {{step}} / 2',
    subtitle:
      'Nous cherchons sans cesse les meilleures opportunités pour vous ! Renseignez vos informations, et nous vous informerons dès que nous aurons des missions à vous proposer :',
    success: {
      body: "Inscrivez-vous et complétez votre profil en 5mn grâce a notre système d'analyse de CV.",
      subtitle: 'Vous y êtes presque !',
      title: 'Découvrez nos missions dans notre application',
    },
    title: 'Oups, il semble qu’aucune offre n’ait été trouvée !',
  },
  no_missions_result: {
    download_app: 'Téléchargez l’application iziwork dès maintenant !',
    subtitle:
      'Nous cherchons sans cesse les meilleures opportunités pour vous ! Téléchargez l’application et nous vous informerons dès que nous aurons des missions à vous proposer.',
    title: 'Oups, il semble qu’aucune offre n’ait été trouvée !',
  },
  salary: {
    gross_per_unit: {
      hourly: 'Brut/heure',
      monthly: 'Brut/mois',
      yearly: 'Brut/an',
    },
  },
  search_params: {
    address: 'ville',
    distance: 'distance',
    experience: 'experience',
    job: 'metier',
    page: 'page',
    sort: 'tri',
    type: 'contrat',
  },
  tags: {
    experience: {
      any: 'Première expérience requise',
      five_years: "Plus de 5 ans d'expérience",
      none: 'Pas d’expérience requise',
      one_month: "Au moins 1 mois d'expérience",
      one_year: "Au moins 1 an d'expérience",
      six_months: "Au moins 6 mois d'expérience",
      three_months: "Au moins 3 mois d'expérience",
      two_years: "Entre 2 ans et 5 ans d'expérience",
    },
  },
  title: {
    '404_error': "Page introuvable - Offres d'emploi iziwork",
    '500_error': "Erreur inconnue - Offres d'emploi iziwork",
    mission_page: 'Emploi iziwork',
    partner_page: "Offres d'emploi",
  },
  toasts: {
    application_error_body: "Votre candidature n'a pas été prise en compte, veuillez réessayer ultérieurement.",
    application_error_title: 'Une erreur est survenue',
  },
  url: {
    askADemo: 'recrutement-interim',
    blog: 'blog',
    companySpace: 'entreprises',
    confidentiality: 'politique-de-confidentialite',
    cookie: 'politique-des-cookies',
    legalMentions: 'mentions-legales',
    partners: 'pourquoi-devenir-partner',
    personalData: 'formulaire-exercice-droits',
    press: 'presse',
    usageConditions: 'conditions-generales-dutilisation',
    who: 'a-propos',
    why: 'pourquoi-iziwork',
  },
  welcome: 'Bienvenue',
  welcome_page: {
    meta_description: 'Retrouvez nos offres à proximité de chez vous et postulez en quelques clics',
    meta_social_description: 'Des postes à pourvoir près de chez vous ! Candidature facile et rapide.',
    meta_social_description_city: 'Des postes à pourvoir près de {{city}} ! Candidature facile et rapide.',
    meta_social_title: 'Accédez à nos offres d’emploi autour de chez vous',
    meta_social_title_city: "Nos offres d'emploi près de {{city}}",
    'meta_social_title_city&zipcode': "Nos offres d'emploi près de {{city}} ({{zipcode}})",
    meta_title: 'Nos offres d’emploi - iziwork',
    meta_title_city: '{{city}} - Nos offres d’emploi - iziwork',
    'meta_title_city&zipcode': '{{city}} ({{zipcode}}) - Nos offres d’emploi - iziwork',
    missions_available_0: 'Aucune offre disponible',
    missions_available_1: '1 offre d’emploi trouvée',
    missions_available_other: '{{count}} offres d’emploi trouvées',
    title_at_your_place: 'chez vous !',
    title_our_offers_near: 'Nos offres\nprès de',
  },
};
